import { render, staticRenderFns } from "./NewUser.vue?vue&type=template&id=60b17324&scoped=true&"
import script from "./NewUser.vue?vue&type=script&lang=js&"
export * from "./NewUser.vue?vue&type=script&lang=js&"
import style0 from "./NewUser.vue?vue&type=style&index=0&id=60b17324&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b17324",
  null
  
)

export default component.exports